import React from 'react';
import LocationTemplate from './LocationTemplate';

const NewBernPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="New Bern"
      stateName="North Carolina"
      countyName="Craven"
      zipCodes={["28560", "28561", "28562", "28563"]}
      latitude={35.1082}
      longitude={-77.0441}
      population={30085}
      historicalFact="Founded in 1710, it was the colonial capital of North Carolina and named after Bern, Switzerland."
      nearbyTowns={[
        "Kinston, NC",
        "Washington, NC",
        "Greenville, NC",
        "Havelock, NC",
        "Morehead City, NC",
        "Jacksonville, NC",
        "Beaufort, NC",
        "Oriental, NC"
      ]}
    />
  );
};

export default NewBernPage;